import moment from "moment";
import React, { useEffect, useState } from "react";

export default function UtilityTimeOfDay({ cue }) {
	const [t, setT] = useState();
	const [i, setI] = useState(null);

	useEffect(() => {
		clearInterval(i);

		setI(
			setInterval(() => {
				let now = moment();
				setT(now);
			}, 100)
		);

		return () => {
			clearInterval(i);
		};
	}, []);
	return (
		<div className="w-screen h-screen flex items-center justify-center ">
			<span className="p-s4 text-s12xl font-bold font-mono bg-gray-800 rounded-ssm">
				{moment(t)
					.add(cue.timezoneOffset || 0, "hour")
					.format(cue.format || "HH:mm:ss")}
			</span>
		</div>
	);
}
